import React, { useEffect } from "react"
import { Link } from "gatsby"
import { PrimaryButton } from "../components/Buttons"
import { Container, CardSet } from "../components/Sections"
import ContactPageTemplate from "./ContactPageTemplate"

const IndexPageTemplate = ({ heading, subheading, posts = [] }) => {
  const goTo = id => {
    const element = document.getElementById(id)
    element.scrollIntoView({
      behavior: "smooth",
    })
  }

  useEffect(() => {
    const hash = window.location.hash
    if (hash) {
      const sectionId = hash.substring(1)
      goTo(sectionId)
    }
    const typewriter = document.querySelector(".typewriter")
    if (typewriter) {
      setTimeout(() => {
        typewriter.classList.add("hide-border")
      }, 2500)
    }
  }, [])

  return (
    <div className="bg-secondary-light">
      {/* Header */}
      <div className="relative mt-16 overflow-hidden md:mt-20 bg-primary-dark">
        <img
          src="/img/1.png"
          alt="bg"
          className="absolute inset-0 w-full h-full"
        />
        <Container id="sobre">
          <div className="py-5 mx-auto text-center max-w-7xl">
            <h3 className="mb-20 text-2xl font-semibold text-white uppercase font-rasputin tracking-extra">
              Bem-vindo!
            </h3>
            <h1 className="-mx-4 text-3xl text-primary-light font-tan-pearl lg:text-7xl tracking-extra fade-in">
              {heading}
            </h1>
            <h2 className="my-8 text-lg leading-normal uppercase md:text-xl text-primary-light font-rasputin tracking-extra fade-in">
              {subheading}
              <br />
              by Patrícia Bouças
            </h2>
            <PrimaryButton
              to="#"
              className="mt-6"
              onClick={e => {
                e.preventDefault()
                goTo("contactos")
              }}
            >
              Pedido de Contacto
            </PrimaryButton>
          </div>
        </Container>
      </div>

      <div className="relative">
        <img
          src="/img/2.png"
          alt="bg"
          className="absolute inset-0 w-full h-full"
        />
        <Container id="quem-somos">
          <div className="flex flex-col md:flex-row gap-x-7">
            <div className="w-full md:w-7/12">
              <h2 className="mb-4 text-3xl text-primary-dark md:text-4xl md:mb-14 font-rasputin tracking-extra fade-in">
                QUEM SOMOS
              </h2>
              <p className="mt-4 text-justify text-black text-open-sans md:text-lg">
                Pérola Branca foi criada a 10 de outubro de 2024, por Patrícia
                Bouças. A missão desta empresa consiste em ajudar a quem a si
                recorre para alcançar a sua casa de sonho. Deste modo, queremos
                substituir o peso que sobre os clientes recai na altura da
                planificação e projeção do interior de sua casa pelo prazer de
                criar um espaço pessoal e único. Estamos aqui para concretizar
                sonhos, tornando tudo muito mais especial, com um pequeno toque
                de magia.
              </p>
            </div>
            <div className="w-full md:w-5/12">
              <img src="/img/logo.png" alt="patricia bouças logo" />
            </div>
          </div>
        </Container>
      </div>

      <div className="relative">
        <img
          src="/img/3.png"
          alt="bg"
          className="absolute inset-0 w-full h-full"
        />
        <Container id="patricia">
          <div className="flex flex-col-reverse md:flex-row gap-x-20">
            <div className="w-full mt-8 md:w-5/12 md:mt-0">
              <img
                src="/img/patrb.webp"
                className="flex mx-auto pb-max-width"
                alt="patricia bouças foto"
              />
            </div>
            <div className="w-full md:w-7/12">
              <h2 className="mb-4 text-xl uppercase text-primary-dark md:text-4xl md:mb-14 font-rasputin tracking-extra md:text-right">
                Patrícia Bouças
              </h2>
              <p className="text-justify text-black text-open-sans md:text-lg">
                Natural de Rossas, Vieira do Minho, a nossa CEO é uma pessoa
                puramente ligada às artes e à essência do feminino. É decoradora
                e designer de interiores, cantora profissional, consultora de
                beleza Mary Kay e bailarina de danças latinas. O amor e o
                entusiasmo que trespassa do seu interior por poder ajudar o
                outro na concretização da realização de um sonho aliou-se à
                gratidão, por ela sentida, por lhe ter sido dada a oportunidade
                de acompanhar todo um processo de abertura e partilha de
                inúmeras emoções. Uma mulher sonhadora, dedicada e responsável,
                onde o seu principal objetivo perante o outro é escutar e
                interpretar o seu design de sonho, tornando-o real de uma forma
                especial.
              </p>
            </div>
          </div>
        </Container>
      </div>

      <div className="relative">
        <img
          src="/img/4.png"
          alt="bg"
          className="absolute inset-0 z-10 w-full h-full"
        />
        <Container id="servicos">
          <div className="">
            <h2 className="text-3xl text-center uppercase text-primary-dark md:text-4xl md:mb-3 font-rasputin tracking-extra fade-in">
              Serviços
            </h2>
            <div className="flex flex-col pt-10 md:flex-row gap-x-7">
              <div className="flex w-full mb-10 md:w-1/3 md:mb-0">
                <img
                  src="/img/proj.png"
                  className="z-20 mx-auto mb-4 md:mb-0 max-h-60"
                  alt="patricia bouças foto"
                />
              </div>
              <div className="flex w-full md:w-1/3">
                <img
                  src="/img/estof.png"
                  className="z-20 mx-auto mb-4 md:mb-0 max-h-60"
                  alt="patricia bouças foto"
                />
              </div>
              <div className="flex w-full md:w-1/3">
                <img
                  src="/img/dec.png"
                  className="z-20 mx-auto mb-4 md:mb-0 max-h-60"
                  alt="patricia bouças foto"
                />
              </div>
            </div>
          </div>
        </Container>
      </div>

      <div
        className="pt-20 bg-primary-dark"
        style={{
          background:
            "linear-gradient(180deg, rgb(218, 203, 200) 0%, rgba(104, 30, 47, 1) 14%)",
        }}
      >
        <Container id="projetos">
          <div>
            <h2 className="text-3xl text-center uppercase text-secondary-light-2 md:text-4xl md:mb-3 font-rasputin tracking-extra fade-in">
              PROJETOS
            </h2>
            <div className="flex flex-col pt-10 pb-5 md:flex-row gap-x-7">
              <div className="w-full mb-10 md:w-1/2">
                <img
                  src="/img/pb2.png"
                  className="mb-4"
                  alt="patricia bouças foto"
                />
                <h3 className="text-lg uppercase text-secondary-light md:text-2xl font-rasputin tracking-extra">
                  Quarto de casal
                </h3>
              </div>
              <div className="w-full md:w-1/2">
                <img
                  src="/img/pb1.png"
                  className="mb-4"
                  alt="patricia bouças foto"
                />
                <h3 className="mb-1 text-lg uppercase text-secondary-light md:text-2xl font-rasputin tracking-extra">
                  SALA DE ESTAR | JANTAR
                </h3>
                <p className="text-justify text-secondary-light font-open-sans md:text-lg">
                  Open Space onde os tons neutros transmitem o conforto,
                  tranquilidade e leveza requerida pelo casal. Um espaço pronto
                  para acolher os seus convidados.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </div>

      {/* Blog */}
      <div className="bg-secondary-light-2">
        <Container id="blog">
          <div className="flex items-baseline justify-between">
            <h2 className="mx-auto text-3xl uppercase text-secondary-light md:text-4xl md:mb-6 font-rasputin tracking-extra fade-in">
              BLOG
            </h2>
            <Link
              className="underline text-primary-dark hover:font-bold"
              to="/projects"
            >
              Ver todos
            </Link>
          </div>
          <div className="mt-8">
            <CardSet posts={posts} />
          </div>
        </Container>
      </div>

      <ContactPageTemplate />

      <div className="relative">
        <img
          src="/img/8.png"
          alt="bg"
          className="absolute inset-0 w-full h-full"
        />
        <Container id="informacoes">
          <div className="">
            <h2 className="text-2xl text-center uppercase text-primary-dark md:text-4xl md:mb-14 font-rasputin tracking-extra fade-in">
              INFORMAÇÕES
            </h2>
            <div className="flex flex-col gap-4 py-10 md:flex-row md:gap-7">
              <div className="w-full p-4 border-2 md:w-1/3 border-secondary-light-2">
                <h4 className="mb-3 text-sm tracking-widest text-black uppercase font-rasputin">
                  Contactos
                </h4>
                <p className="flex mb-2 text-sm text-black font-open-sans">
                  <img
                    src="/img/localizacao.png"
                    alt="localizacao"
                    className="inline w-6 h-6 pr-2"
                  />
                  <span className="inline">
                    Rua do Fujacal, nº62
                    <br />
                    4705 - 097 Braga - PT
                  </span>
                </p>
                <p className="mb-2 text-sm text-black font-open-sans">
                  <img
                    src="/img/tlm.png"
                    alt="telemovel"
                    className="inline w-6 pr-2"
                  />
                  +351 935 129 310
                </p>
                <p className="text-sm text-black font-open-sans">
                  <img
                    src="/img/email.png"
                    alt="email"
                    className="inline w-6 pr-2"
                  />
                  perolla.brancca@gmail.com
                </p>
              </div>
              <div className="w-full p-4 border-2 md:w-1/3 border-secondary-light-2">
                <h4 className="mb-3 text-sm tracking-widest text-black uppercase font-rasputin">
                  Horário de Atendimento
                </h4>
                <p className="mb-2 text-sm text-black font-open-sans">
                  Segunda a Sexta
                  <br />
                  09:00h - 12:30h
                  <br />
                  14:00h - 18:30h
                </p>
                <p className="text-sm text-black font-open-sans">
                  Sábado
                  <br />
                  09:00h - 12:30
                </p>
              </div>
              <div className="relative z-50 w-full p-4 border-2 md:w-1/3 border-secondary-light-2">
                <h4 className="mb-3 text-sm tracking-widest text-black uppercase font-rasputin">
                  Redes Sociais
                </h4>
                <button
                  rel="noopener noreferrer"
                  className="w-full mb-2 text-sm text-left text-black font-open-sans"
                  onClick={e => {
                    e.preventDefault()
                    window.location.href =
                      "https://www.instagram.com/perola_branca10"
                  }}
                >
                  <img
                    src="/img/insta.png"
                    alt="instagram"
                    className="inline w-10 pr-2"
                  />
                  perola_branca10
                </button>
                <button
                  className="w-full text-sm text-left text-black font-open-sans"
                  onClick={e => {
                    e.preventDefault()
                    window.location.href =
                      "https://www.facebook.com/profile.php?id=61567274627961"
                  }}
                >
                  <img
                    src="/img/fb.png"
                    alt="facebook"
                    className="inline w-10 pr-2"
                  />
                  Pérola Branca
                </button>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default IndexPageTemplate
